import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { MspConfigCardState } from '../../../types/msp-config';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'msp-config-card-wrapper',
  templateUrl: './msp-config-card-wrapper.component.html',
  styleUrls: ['./msp-config-card-wrapper.component.scss'],
  standalone: false,
})
export class MspConfigCardWrapperComponent implements OnInit {
  /**
   * The state of the card
   */
  @Input()
  cardState: MspConfigCardState = 'view';

  /**
   * True if the confirmation dialog should be shown
   */
  @Input()
  showConfirmationDialog: boolean = false;

  /**
   * The title of the card
   */
  @Input()
  title: string = 'Configuration card';

  /**
   * The icon of the card
   */
  @Input()
  icon: string = 'settings';

  /**
   * The width of the card
   */
  @Input()
  width: string = '500px';

  /**
   * The height of the card
   */
  @Input()
  height: string = 'auto';

  /**
   * The title of the dialog
   */
  @Input()
  dialogTitle: string;

  /**
   * The message of the dialog
   */
  @Input()
  dialogMessage: string;

  /**
   * True if the save button should be disabled
   */
  @Input()
  isSaveDisabled: boolean = false;

  /**
   * True if the buttons should be shown
   */
  @Input()
  showButtons: boolean = true;

  /**
   * True if the edit button should be shown (hide for view-only users)
   */
  @Input()
  canEdit: boolean = true;

  /**
   * The error message to display in the save/update button
   */
  @Input()
  errorMessage: string = '';

  /**
   * Method to be called when the save button is clicked
   */
  @Output()
  onSave: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Method to be called when the cancel button is clicked
   */
  @Output()
  onCancel: EventEmitter<void> = new EventEmitter<void>();

  /**
   * Method to be called when the edit button is clicked
   */
  @Output()
  onEdit: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('dialogContent') content: TemplateRef<any>;

  constructor(private matDialog: MatDialog) {}

  ngOnInit(): void {}

  /**
   * Emits the onSave, onCancel or onEdit event
   * @param action - The action to be performed
   */
  onButtonActionClick(action: 'onSave' | 'onCancel' | 'onEdit') {
    this[action].emit();
  }

  /**
   * Triggers the dialog to open when the user clicks on the update... button
   * @returns void
   */
  triggerDialog() {
    this.matDialog.open(ConfirmDialogComponent, {
      maxWidth: '700px',
      minHeight: '210px',
      data: {
        title: this.dialogTitle,
        message: this.dialogMessage,
        confirmAction: () => {
          this.onSave.emit();
        },
        autoCloseOnConfirm: true,
      },
    });
  }
}
